import { ApiMedia } from '~/passporter-services/media/apitype'
import {
	ApiWallPin,
	ApiTextWallPin,
	API_WALL_PIN_TYPE,
	ApiLinkWallPin,
	ApiMediaWallPin,
} from './apiTypes'
import { WallPin, TextWallPin, WALL_PIN_TYPE, LinkWallPin, MediaWallPin } from '~/models/WallPin'

export class WallPinApiMapper {
	static toWallPin(wallPin: WallPin): ApiWallPin {
		const wallPinMappers: Record<WALL_PIN_TYPE, (wallpin: WallPin) => ApiWallPin> = {
			[WALL_PIN_TYPE.TEXT]: (wallPin: WallPin) => this.mapText(wallPin as TextWallPin),
			[WALL_PIN_TYPE.LINK]: (wallPin: WallPin) => this.mapLink(wallPin as LinkWallPin),
			[WALL_PIN_TYPE.MEDIA]: (wallPin: WallPin) => this.mapMedia(wallPin as MediaWallPin),
		}
		return wallPinMappers[wallPin.type](wallPin)
	}

	private static mapText(wallPin: TextWallPin): ApiTextWallPin {
		return {
			type: API_WALL_PIN_TYPE.TEXT,
			data: wallPin.data,
		}
	}

	private static mapLink(wallPin: LinkWallPin): ApiLinkWallPin {
		return {
			type: API_WALL_PIN_TYPE.LINK,
			data: { url: wallPin.data.url },
		}
	}

	private static mapMedia(wallPin: MediaWallPin): ApiMediaWallPin {
		return {
			type: API_WALL_PIN_TYPE.MEDIA,
			data: {
				id: wallPin.data.id,
			} as ApiMedia,
		}
	}
}
